import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'afoone-wxrl-formula-drawer',
  templateUrl: './wxrl-formula-drawer.component.html',
  styleUrls: ['./wxrl-formula-drawer.component.css'],
})
export class WxrlFormulaDrawerComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() formula: string = '';
  @Input() negRule: boolean = false;
  @Input() conditions: Array<{ condRule: string; kommentar: string }> = [];

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() saveAndFinish = new EventEmitter<{ condition: string; negRule: boolean }>();
  @Output() cancel = new EventEmitter<void>();

  public formulaForm: FormGroup;

  constructor(private _fb: FormBuilder) {
    this.formulaForm = this._fb.group({
      condition: [''],
      negRule: [false],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      // Poblar el formulario cuando se abre el drawer
      this.formulaForm.patchValue({
        condition: this.formula || '',
        negRule: this.negRule || false,
      });
    } else if (changes['visible'] && !this.visible) {
      // Resetear el formulario cuando se cierra
      this.formulaForm.reset();
    }
  }

  onSaveAndFinish(): void {
    if (this.formulaForm.valid) {
      const formValue = this.formulaForm.value;
      this.saveAndFinish.emit({
        condition: formValue.condition || '',
        negRule: formValue.negRule || false,
      });
    }
  }

  onCancel(): void {
    this.visibleChange.emit(false);
    this.cancel.emit();
  }

  onVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }
}
